import { connect } from 'react-redux';
import KelolaPindahKelas from '../../../views/Akademi/DataKelas/KelolaPindahKelas.view';
import { getClasses, getLevels } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    classes: state.options.classes,
    levels: state.options.levels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    handleGetLevels: payload => dispatch(getLevels(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(KelolaPindahKelas);
